!((document, Drupal, $) => {
  'use strict';
  Drupal.behaviors.exposedForms = {
    attach: function(context) {
      // Only run once.
      if (context !== document) {
        return;
      }

      const $inputWrapper = $('.js-form-item', context);

      // $inputWrapper.each(function() {
      //   const $input = $(this).find('input');

      //   $(this).prepend($input);
      // });
    }
  };
})(document, Drupal, jQuery);
